
import { Imagemodel } from './imagemodel';

import { User } from './user';

export class Car {
    carId:number;
    carName:string;
    carType:string;
    color:String;
    modelNo:string;
    price:number;
    offer:number;
    dicountOnRegistration:number
    startManufcat:Date;
    endManufat:Date;
    startReg:Date;
    endReg:Date;
     deliverydate:Date;
    // imagemodel:Imagemodel;
    brand?: string;
    model?: string;
    year?: number;
    description?: string;
    image_id:number;
    imageName?: string;
     
     //picByte: string;
    //retrievedImage: string;
    //selectedFile: File;
  //retrievedImage: any;
 // base64Data: any;
  //retrieveResonse: any;
  //message: string;
  //imageName: any;
   //imageId:number;
    

}

